import { format } from '../../modules/helpers.js';
import getSchoolColor from './getSchoolColor';
import * as d3 from 'd3';
import isSmallProjectedNode from './isSmallProjectedNode'; 

function addNodes(
  nodesGroup,
  nodesData,
  schoolWithLineNodes,
  getDateFromIndex,
  handleClick,
  multiplier,
  x,
  y,
  isActiveSchoolSmall 
) {
  const nodes = nodesGroup.selectAll('.circle').data(nodesData);

  nodes
    .enter()
    .filter(function(d) { return !isNaN(d) })
    .append('circle')
    .attr('class', 'circle')
    .style('fill', (d, i) => {
      if (i === 0) return 'white';
      return getSchoolColor(schoolWithLineNodes)(schoolWithLineNodes);
    })
    .style('stroke', (d, i) => {
      if (i > 0) return 'white';
      return getSchoolColor(schoolWithLineNodes)(schoolWithLineNodes);
    })
    .style('cursor', 'pointer')
    .attr('tabindex', 0)
    .attr('cx', (d, i) => x(getDateFromIndex(i)))
    .attr('cy', (d, i, e) => { 
      if (isSmallProjectedNode(i)) { 
        const currentYear = e[1].__data__; 
        return y(currentYear); 
      } 
      return y(d); 
    })
    .on('mouseover', handleClick)
    .on('click', function(d, i) { 
      const e = d3.event; 
      e.stopPropagation(); 
    }) 
    .on('keydown', function(d, i) {
      const e = d3.event;
      const keys = {
        SPACE: 32,
        ENTER: 13,
      };
      if (
        e.type === 'click' ||
        e.keyCode === keys.SPACE ||
        e.keyCode === keys.ENTER
      ) {
        handleClick.call(this, d, i);
      }
    })
    .merge(nodes)
    .style('stroke-width', () => {
      return 3 * multiplier + 'px';
    })
    .transition()
    .attr('r', () => 6 * multiplier)
    .attr('cx', (d, i) => x(getDateFromIndex(i)))
    .attr('cy', (d, i, e) => { 
      if (isSmallProjectedNode(i) && isActiveSchoolSmall) { 
        const currentYear = e[1].__data__; 
        return y(currentYear); 
      } 
      return y(d); 
    }); 

  const textLabels = nodesGroup.selectAll('.text-label').data(nodesData);

  textLabels
    .enter()
    .filter(function(d) { return !isNaN(d) })
    .append('text')
    .attr('class', 'text-label')
    .text((d, i, e) => { 
      if (i === 0) return ''; 
      if (i === 1) return ''; 
      if (isSmallProjectedNode(i) && isActiveSchoolSmall) { 
        const currentYear = e[1].__data__; 
        d = currentYear; 
      } 
      return `${(d < 0 ? '' : '+') + format(d, 0)}%`; 
    }) 
    .attr('x', (d, i) => x(getDateFromIndex(i)))
    .merge(textLabels)
    .attr('text-anchor', 'middle')
    .attr('y', (d, i, e) => { 
      if (isSmallProjectedNode(i) && isActiveSchoolSmall) { 
        const currentYear = e[1].__data__; 
        return y(currentYear) - 15 * multiplier; 
      } 
      return y(d) - 15 * multiplier; 
    });

  nodesGroup.moveToFront();
}

export default addNodes;



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/addNodes.js